import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Toggle from '../../../../components/common/toggleButton';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../../components/common/tooltip';
import InputField from '../../../../components/common/input-field';
import { toolTipInfo } from '../../../utils/constants';

export interface WidthProps {
  value: IWidthComponentProps;
  onChange: (_value: IWidthComponentProps) => void;
  title?: string;
  withoutPercentage?: boolean;
}

export interface IWidthComponentProps {
  width: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  deviceType: string;
}

const WidthComponent: React.FC<WidthProps> = ({
  onChange,
  value,
  title = 'Width',
  withoutPercentage = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={() => setIsOpen(!isOpen)}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="grid gap-4 mt-3 border border-gray-300 rounded p-2">
          <Toggle<IWidthComponentProps>
            value={value}
            onChange={newValue => onChange({ ...value, ...newValue })}
            heading={{ label: 'Device', value: 'device' }}
            options={[
              { label: 'Desktop', value: 'desktop' },
              { label: 'Tablet', value: 'tablet' },
              { label: 'Mobile', value: 'mobile' },
            ]}
            propName="deviceType"
          />
          <FieldLabel
            label={
              (
                <CustomTooltip title={title as keyof typeof toolTipInfo}>
                  <span>{title}</span>
                </CustomTooltip>
              ) as React.ReactNode as string
            }>
            <InputField
              value={value?.width?.[value.deviceType]}
              className="h-[42px]"
              onChange={e => {
                const newValue = e.replace(/[^0-9%]/g, '');
                const newNumberValue = e.replace(/[^0-9]/g, '');
                onChange({
                  ...value,
                  width: {
                    ...value?.width,
                    [value?.deviceType]: withoutPercentage
                      ? newNumberValue
                      : newValue || 'none',
                  },
                });
              }}
            />
          </FieldLabel>
        </div>
      )}
    </div>
  );
};

export default WidthComponent;
